import { render, staticRenderFns } from "./PurchaseRegister.vue?vue&type=template&id=733ec202&"
import script from "./PurchaseRegister.vue?vue&type=script&lang=js&"
export * from "./PurchaseRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports